<div
  class="bg-white grid grid-cols-2 w-[106px] gap-2 px-4 py-2 shadow-detail rounded-[12px] h-[150px]"
>
  <div
    class="col-span-1 flex flex-col gap-3 h-full overflow-scroll hide-scrollbar"
  >
    @for (hour of hours; track $index) {
    <div
      class="flex justify-center items-center rounded-[4px] cursor-pointer"
      [ngClass]="{ 'bg-teal-seed text-white': hour === currentHour }"
      (click)="setCurrentHour(hour)"
    >
      {{ hour | padStart : 2 }}
    </div>
    }
  </div>
  <div
    class="col-span-1 flex flex-col gap-3 h-full overflow-scroll hide-scrollbar"
  >
    @for (minute of minutes; track $index) {
    <div
      class="flex justify-center items-center rounded-[4px] cursor-pointer"
      [ngClass]="{ 'bg-teal-seed text-white': minute === currentMinute }"
      (click)="setCurrentMinute(minute)"
    >
      {{ minute | padStart : 2 }}
    </div>

    }
  </div>
</div>
